// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KK0oL","largestCol":"styles_largestCol__1k8Hf","smallestCol":"styles_smallestCol__1LtJn"};